
import { Modal } from "react-bootstrap";
import DatePickerInput from "../common/datePickerInput";
import { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import InputFiled from "../common/inputFiled";
import ButtonSubmit from "../common/buttonSubmit";
import BoxEmailService from "../boxEmailService";
import ButtonsRadio from "../common/buttonsRadio";
import ErrorMessageBox from "../common/errorMessageBox";
import { useSelector } from "react-redux";
import { HttpService } from "../../services/HttpService";
import SuccessMessageBox from "../common/successMessageBox";
import InputSwitch from "../common/inputSwitch";

const PopUpEmailSchedule = (props: any) => {
  let show = props.show ?? true;
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timeSchedule, setTimeSchedule] = useState("");
  const [emails, setEmails] = useState<null | any>([]);
  const [repeatEmailSchedule, setRepeatEmailSchedule] = useState("allDay");
  const [emailScheduleActivated, seteEmailScheduleActivated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { eventId } = useSelector((state: any) => state.login);
  const [htmlEmailId, setHtmlEmailId] = useState("");
  const [idEmailSchedule, setIdEmailSchedule] = useState("");
  const [loaderSpinner, setLoaderSpinnner] = useState(false);

  const isDisabledSubmit = () => {
    let check = false;
    if (!timeSchedule || !emails.length) {
      check = true
    }
    if (repeatEmailSchedule === "forAPeriod" && (!endDate || !startDate)) {
      check = true
    }

    return check
  }

  const initEmailSchedule = async () => {
    setSuccessMessage("")
    let result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/cronjob/eventExport`);
    if (result.data.length) {
      let emailSchedule = result.data[0];
      let startDate = ((emailSchedule.startDate) ? moment(emailSchedule.startDate).format("DD-MM-YYYY") : "");
      let timeSchedule = ((emailSchedule.startDate) ? moment(emailSchedule.startDate).format("HH:mm") : "");
      let endDate = ((emailSchedule.endDate) ? moment(emailSchedule.endDate).format("DD-MM-YYYY") : "");
      setIdEmailSchedule(emailSchedule._id);
      setStartDate(startDate);
      setTimeSchedule(timeSchedule)
      setEndDate(endDate);
      setHtmlEmailId(emailSchedule.data.htmlEmailId);

      if (emailSchedule.frequency && emailSchedule.frequency.weekdays.length) {
        setRepeatEmailSchedule("forAPeriod")
      }
      if (emailSchedule.data && emailSchedule.data.emails.length) {
        setEmails(emailSchedule.data.emails)
      }
      if (!emailSchedule.done) {
        seteEmailScheduleActivated(true)
      }
      else {
        seteEmailScheduleActivated(false)
      }

    }
    else {
      setIdEmailSchedule("");
      setStartDate("");
      setTimeSchedule("")
      setEndDate("");
      setHtmlEmailId("");
      setRepeatEmailSchedule("allDay");
      setEmails([]);
    }
  }

  const saveOrEditCronjob = async () => {
    try {
      setLoaderSpinnner(true);
      setSuccessMessage("");
      setErrorMessage("");

      let dayStart = ((startDate && repeatEmailSchedule !== "allDay") ? startDate : moment().format("DD-MM-YYYY"));
      console.log(dayStart);
      let objectEmailSchedule: any =
      {
        "startDate": moment(dayStart + " " + timeSchedule, "DD-MM-YYYY HH:mm").toDate(),
        "endDate": ((endDate && repeatEmailSchedule !== "allDay") ? moment(endDate, "DD-MM-YYYY").toDate() : ""),
        "process": "eventExport",
        "done": ((!emailScheduleActivated) ? true : false),
        "frequency": {
          "unit": "days",
          "quantity": 1,
          "weekdays": []
        },
        "data": {
          "createExport": false,
          "isCalendarTomorrow": true,
          "eventId": eventId,
          "emails": emails
        }
      };
      if (idEmailSchedule) {
        objectEmailSchedule.data.htmlEmailId = htmlEmailId;
        await HttpService.put(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/cronjob/${idEmailSchedule}`, objectEmailSchedule);
        setSuccessMessage(t('save-email-schedule'))
      }
      else {
        const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/cronjob`, objectEmailSchedule);
        if (result.data._id) {
          setIdEmailSchedule(result.data._id);
          setHtmlEmailId(result.data.data.htmlEmailId);
        }
        setSuccessMessage(t('create-email-schedule'))
      }
      setLoaderSpinnner(false);
    }
    catch (error: any) {
      setLoaderSpinnner(false)
      setErrorMessage(t(`error.${error.response.data.result.key || "generic"}`))
    }

  }

  useEffect(() => {
    initEmailSchedule()
  }, [show])

  return (
    <Modal className="ModalSection EditCategoryTimeslot PopUpEmailSchedule =" show={show} onHide={props.closePopUp}>
      <Modal.Header closeButton>
        {t('popup-email-schedule.title-modal')}
      </Modal.Header>
      <Modal.Body>
        <div className="col-lg-12 ">
          <p>{t('popup-email-schedule.info')}</p>
          <InputSwitch onChange={seteEmailScheduleActivated} nameComponent="emailScheduleActivated" checked={emailScheduleActivated} label={((emailScheduleActivated) ? t('popup-email-schedule.active') : t('popup-email-schedule.not-active'))} />


          <div className="pt-2 SelectBox col-12">
            <label >{t('popup-email-schedule.label-time-schedule')}</label>
            <InputFiled disabled={!emailScheduleActivated} value={timeSchedule} handleChange={setTimeSchedule} type="time" />
          </div>
          <div className="pt-2 SelectBox col-12">
            <label >{t('popup-email-schedule.label-repeat')}</label>
            <ButtonsRadio disabled={!emailScheduleActivated} value={repeatEmailSchedule} onChange={setRepeatEmailSchedule} nameComponent={"repeatEmailSchedule"} options={[{ value: "allDay", name: t('popup-email-schedule.all-day') }, { value: "forAPeriod", name: t('popup-email-schedule.for-a-period') }]} />
          </div>

          {((repeatEmailSchedule === "forAPeriod") ?
            <>
              <div className="pt-2">
                <DatePickerInput
                  className="w-100"
                  disabled={!emailScheduleActivated}
                  handleChange={setStartDate}
                  firstSelect="Seleziona data"
                  dateSelected={((startDate) ? new Date(moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD")) : null)}
                  label={t('popup-email-schedule.label-start-date')}
                />
              </div>
              <div className="pt-2">
                <DatePickerInput
                  className="w-100"
                  handleChange={setEndDate}
                  firstSelect="Seleziona data"
                  disabled={!emailScheduleActivated}
                  dateSelected={((endDate) ? new Date(moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD")) : null)}
                  label={t('popup-email-schedule.label-end-date')}
                />
              </div>
            </>
            : <></>)}
          <div className="pt-2 SelectBox">
            <label >{t('popup-email-schedule.label-email')}</label>
            <BoxEmailService disabled={!emailScheduleActivated} handelUpdate={setEmails} emails={emails} />
          </div>
          <div className="pt-2 SelectBox">
            <p className="text-danger">{t('required-fields')}</p>
          </div>
          <div className="pt-2">
            <ErrorMessageBox errorMessage={errorMessage} />
            <SuccessMessageBox successMessage={successMessage} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-2">
          {((idEmailSchedule) ?
            <ButtonSubmit spinner={loaderSpinner} disabled={isDisabledSubmit()} handleChange={() => (saveOrEditCronjob())} textButton={t('save')} />
            :
            <ButtonSubmit spinner={loaderSpinner} disabled={isDisabledSubmit()} handleChange={() => (saveOrEditCronjob())} textButton={"Crea"} />
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default PopUpEmailSchedule